export default {"src":"/_next/static/media/size-limit-hero-10mb.7858d760.svg","height":154,"width":301,"blurWidth":0,"blurHeight":0};